// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import InputBlurChange from "metabase/components/InputBlurChange";

export const FieldNameInput = styled(InputBlurChange)`
  width: auto;
  margin-bottom: 0.5rem;
`;
